var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_177",
    "data-name": "Group 177",
    transform: "translate(-1125 -245)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    transform: "translate(1125 245)",
    fill: "#0f0b19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pin_Icon",
    "data-name": "Pin Icon",
    d: "M12.966.108l5.959,5.959a.24.24,0,0,1,0,.338L16.9,8.435a.239.239,0,0,1-.338,0l-.577-.577-2.675,2.674a6.778,6.778,0,0,1-1.758,6.542q-.061.062-.125.122c-.155.148-.13.147-.28,0L7.358,13.407,0,19.032l5.627-7.356L1.836,7.885c-.151-.151-.138-.128.01-.284l.114-.116A6.78,6.78,0,0,1,8.5,5.727l2.674-2.674L10.6,2.476a.24.24,0,0,1,0-.338L12.628.108a.24.24,0,0,1,.338,0Z",
    transform: "translate(1133.5 253.462)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinIcon);
export default __webpack_public_path__ + "static/media/PinIcon.d4f51365b88726625887ef560ae04ff9.svg";
export { ForwardRef as ReactComponent };